import React, { useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { jsx } from 'react/jsx-runtime';

const AuthContext = /*#__PURE__*/React.createContext({
  user: null,
  setUser: () => {}
});
const useAuthContext = () => useContext(AuthContext);
const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  children: PropTypes.node.isRequired
};
const defaultProps = {
  user: null
};
function AuthProvider(_ref) {
  let {
    user: providedUser,
    children
  } = _ref;
  const [stateUser, setUser] = useState(null);
  const value = useMemo(() => ({
    user: stateUser || providedUser,
    setUser
  }), [stateUser, providedUser, setUser]);
  return /*#__PURE__*/jsx(AuthContext.Provider, {
    value: value,
    children: children
  });
}
AuthProvider.propTypes = propTypes;
AuthProvider.defaultProps = defaultProps;

function useLoggedIn() {
  const {
    user
  } = useAuthContext();
  return user !== null;
}

function useUser$1() {
  const {
    user
  } = useAuthContext();
  return user || null;
}

function useUser() {
  const {
    setUser
  } = useAuthContext();
  return setUser;
}

export { AuthContext, AuthProvider, useAuthContext, useLoggedIn, useUser as useSetUser, useUser$1 as useUser };
